function decycle(obj: any, stack: any[] = []): any {
    if (!obj || typeof obj !== "object") return obj;

    if (stack.includes(obj))
        return `<Circular<${obj.constructor?.name ?? typeof obj}>>`;

    const s = stack.concat([obj]);

    return Array.isArray(obj)
        ? obj.map((x) => decycle(x, s))
        : Object.fromEntries(
              Object.entries(obj).map(([k, v]) => [k, decycle(v, s)])
          );
}

export default (obj: any): string => JSON.stringify(decycle(obj));
